var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data && _vm.data.attrs && _vm.isMobileView)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ContentFragment',{attrs:{"content":_vm.data}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }